import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { HaCasegroupcreationServiceService } from '../../services/HaCaseGroupCreation.service';
import { HtmlAstPath } from '@angular/compiler';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-case-group-creation',
  templateUrl: './ha-case-group-creation.component.html',
  styleUrls: ['./ha-case-group-creation.component.css']
})

export class HaCaseGroupCreationComponent implements OnInit {
  dateSelect;
  caseGroupList: any[];
  element: HTMLElement;
  elementIcd: HTMLElement;
  elementCpt: HTMLElement;
  elementPre: HTMLElement;
  elementProc: HTMLElement;
  elementMed: HTMLElement;
  elementVendor: HTMLElement;
  elementMain: HTMLElement;
  currentList: any[];
  caseGroupId: string;
  showOverlayCaseGroup: boolean;
  defaultPage: boolean;
  dataList: any[];
  searchTerm: string = '';
  showAssignedCodes: boolean;
  listView: boolean = false;
  editCase: boolean;
  screenHeight: any;
  screenWidth: any;
  mainViewError = new ErrorModel();
  codesError = new ErrorModel();

  constructor(private route: Router, private _service: HaCasegroupcreationServiceService) {

   }
  ngOnInit() {
    this.showOverlayCaseGroup = true;
    this.dateSelect = new Date().toJSON().split('T')[0];
    this.getCaseGroupList();

  }

  getCaseGroupList() {
    this.showOverlayCaseGroup = true;
    this.mainViewError.display = false;
    this._service.getCaseGroupList().subscribe(
    (data: any[]) => {
      this.caseGroupList = data;
      this.defaultPage =  this.caseGroupList.length <= 0 ? true : false;

    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlayCaseGroup = false;
    });
  }

  onGroupUpdate(eventData) {
    eventData.evt.stopPropagation();
    let index = this.caseGroupList.findIndex(caseIs => caseIs.id == eventData.id);
    let caseValue = this.caseGroupList[index].name;
    if (caseValue == eventData.value) {
      let icdindex = this.caseGroupList.findIndex(caseIs => caseIs.id == eventData.id);
      this.caseGroupList[icdindex].isEdit = false;
    } else {
      let index = this.caseGroupList.filter(caseIs => caseIs.name.toLowerCase().trim() == eventData.value.toLowerCase().trim())[0];
      if (index !== undefined) {
        AlertMessages.Show('Warning', 'Case Group already exists!!!', AlertType.Warning);
        let icdIndex = this.caseGroupList.findIndex(caseIs => caseIs.id == eventData.id);
        this.caseGroupList[icdIndex].isEdit = false;
      } else {
        if (eventData.value == '' || eventData.value == null || eventData.value == undefined) {
          AlertMessages.Show('Warning', 'Please Enter a Valid Case Group Name!!!', AlertType.Warning);
        } else {
          this._service.updateCaseGroupName(eventData.id, eventData.value).subscribe((data) => {

            AlertMessages.Show('Success', 'Case Group Updated Successfully!!!', AlertType.Success);
            let index = this.caseGroupList.findIndex(caseIs => caseIs.id == eventData.id);
            this.caseGroupList[index].name = eventData.value;
            this.caseGroupList[index].isEdit = false;
          });
        }
      }
    }
  }

  editCaseGroup(data) {
    data.evt.stopPropagation();
    this.caseGroupList.forEach(element => {
      element.isEdit = false;
    });
    let index = this.caseGroupList.findIndex(caseIs => caseIs.id == data.id);
    this.caseGroupList[index].isEdit = true;
  }

  onEventDelete(data) {
    data.evt.stopPropagation();
    this.deleteCase(data.id);
  }

  deleteCase(caseId) {
    const response = confirm('Are you sure you want to delete this case group');
    if (response == true) {
      this._service.deleteCaseGroup(caseId).subscribe(
      (data) => {
        AlertMessages.Show('Success', 'Case Group Deleted', AlertType.Success);
        this.closeNav();
        this.caseGroupList.splice(this.caseGroupList.findIndex(caseIs => caseIs.id == caseId), 1);
      },
      (error) => {
        AlertMessages.Show('Failed','Could not Delete!',AlertType.Error);
      });
    }
  }

  //code to navigate to create case group component
  routeToCodes() {
    this.route.navigate(['Hospital/HAAdmin/HaCasegroupCreationCodes'], {});
  }

  //code to insert new case
  insertCase(caseGroupName) {
    this._service.createGroup(caseGroupName).subscribe(
    (data: any) => {
      alert(data);
      this.getCaseGroupList();
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not Insert Case!', AlertType.Error);
    });
  }

  //code to display the slide div for codes associated with selected case group
  openNav(id) {
    for (let caseGroup of this.caseGroupList) {
      caseGroup.border = '';
      caseGroup.borderBottom = '';
    }
    let index = this.caseGroupList.findIndex(caseIs => caseIs.id == id);
    this.caseGroupList[index].border = '2px solid #0969c9';
    this.caseGroupList[index].borderBottom = '2px solid #0969c9';

    this.element = document.getElementById('slideDiv') as HTMLElement;
    this.element.style.marginRight = '0px';
    this.element.style.opacity = '1';
    this.caseGroupId = id;
    this.getCodes('1');
    this.elementMain = document.getElementById('main_content') as HTMLElement;
    this.elementMain.style.width = '70%';
  }

  //closing the slide div for selected group
  closeNav() {
    for (let cases of this.caseGroupList) {
      cases.border = '';
      cases.borderBottom = '';
    }
    this.element = document.getElementById('slideDiv') as HTMLElement;
    this.element.style.marginRight = '-105%';
    this.element.style.opacity = '0';
    this.elementMain = document.getElementById('main_content') as HTMLElement;
    this.elementMain.style.width = '100%';
     this.dataList=[];
  }

  //code to get the codes associated with selected case group
  getCodes(index) {
    this.showAssignedCodes = true;
    this.codesError.display = false;
    this.dataList = [];
    this._service.getCodesByGroups(this.caseGroupId).subscribe(
    (data: any[]) => {
      this.dataList = data;
      this.changeDiv('1');
    },
    (error) => {
      this.codesError.error = error;
      this.codesError.display = true;
    }).add(() => this.showAssignedCodes = false);
  }

  public activeElementCode = '1';
  //code to display the codes as per category icd,cpt,etc
  changeDiv(index) {
    this.elementIcd = document.getElementById('ICD_Div');
    this.elementCpt = document.getElementById('CPT_Div');
    this.elementPre = document.getElementById('Preop_Div');
    this.elementProc = document.getElementById('Proced_Div');
    this.elementMed = document.getElementById('medical_Div');
    this.elementVendor = document.getElementById('vendor_Div');

    switch (index) {
      case '1':
        this.setDivStatus(index,'block','none','none','none','none','none');
        this.currentList = this.dataList['icdCodes'];
        break;
      case '2':
        this.setDivStatus(index,'none','block','none','none','none','none');
        this.currentList = this.dataList['cptCodes'];
        break;
      case '3':
         this.setDivStatus(index,'none','none','none','block','none','none');
          this.currentList = this.dataList['preopCodes'];
         break;
      case '4':
         this.setDivStatus(index,'none','none','none','none','block','none');
          this.currentList = this.dataList['procedures'];
          break;
      case '5':
          this.setDivStatus(index,'none','none','block','none','none','none');
          this.currentList = this.dataList['medDevices'];
          break;
      case '6':
          this.setDivStatus(index,'none','none','none','none','none','block');
          this.currentList = this.dataList['vendors'];
          break;
      default:
          alert('ERROR: Case not valid.....');
    }

  }

  //-----------------------------------
  setDivStatus(index,icd,cpt,med,preOp,procedure,vendor) {
    this.activeElementCode = index;
    this.elementIcd.style.display = icd;
    this.elementCpt.style.display = cpt;
    this.elementMed.style.display = med;
    this.elementPre.style.display = preOp;
    this.elementProc.style.display = procedure;
    this.elementVendor.style.display = vendor;
    this.showAssignedCodes = false;
  }

  onEvent(data) {
    data.evt.stopPropagation();
    this.openNav(data.id);
  }

}
